module.exports = __webpack_public_path__ + "static/img/fenfa_banner.00adaf7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fenfa_banner.png
// module id = TNSs
// module chunks = 1